<template>
  <!-- eslint-disable-next-line vuejs-accessibility/form-control-has-label -->
  <textarea
    class="input-textarea m-reset-input"
    :value="modelValue"
    :rows="rows"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<script setup>
defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  rows: {
    type: Number,
    default: 3,
  },
});
</script>

<style scoped>
.input-textarea {
  border-radius: var(--border-radius-sm);
  border: var(--input-border);
  padding: 15px 14px;
  line-height: 150%;
  &:focus {
    outline: none;
    padding: 14px 13px;
    border: var(--input-border-focus);
    box-shadow: 0px 0px 10px rgba(9, 56, 115, 0.15);
  }
}
</style>
